import { createContext, useContext } from 'react';
import type { ModalContextProps } from './types';

const defaultModalContext: ModalContextProps = {
  showModal: () => {
    return;
  },
  hideModal: () => {
    return;
  },
  modalData: {},
  setModalData: () => {
    return;
  },
};

export const ModalContext =
  createContext<ModalContextProps>(defaultModalContext);

export const useModalContext = () => useContext(ModalContext);
